@use "Styles/mixins";
@use "Styles/includes/variables";

* {
    box-sizing: border-box;
}

:host {
    display: none;

    @include mixins.desktop-and-up {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
}

.vm-video-info-cards {
    &__card {
        --vm-video-info-cards-card-bg: #{mixins.get-color(background, bg-gray-100)};

        padding: 16px 24px;
        border-radius: 16px;
        background-color: var(--vm-video-info-cards-card-bg);

        &--channel {
            display: flex;
            align-items: center;
            gap: 12px;
        }
    }

    &__description {
        p {
            margin: 0;
        }
        flex: 1 0 0;
        min-width: 0;
        font-size: mixins.get-font-size(text-sm);
        line-height: mixins.get-line-height(text-sm);
        color: mixins.get-color(text, text-secondary);
        --vm-clamped-text-bg: var(--vm-video-info-cards-card-bg);

        @include mixins.unsafe-html-links;
    }

    &__learn-more {
        background: mixins.get-color(bg, solid, primary);
        border-radius: 100px;
        flex-shrink: 0;
    }
}
